export const navigation = [
  { label: 'Blog', to: '/blog' },
  { label: 'Experience', to: '/experience' },
  { label: 'About', to: '/about' },
];

export const homepage = {
  
 
  intro: `I believe the modern internet lacks the personality and sincerity it should have. I've always enjoyed the thought of having a personal blog because, to me, it acts as an antithesis to what social media is. Inherently, the blog is more intimate because I can have control over everything on the website. This is opposed to any social media platform, which I believe creates a system of conformity through algorithms and leads to performativity. This website will allow me to write more about who I am, my hobbies, interests, and perspectives than any other platform.`,

  currentWork: 'I currently serve as Student Body President at the University of West Florida, study Computer Science and Mathematics, and work as a Data Analyst Intern.',
  
  about: 'Beyond work and school, I care about books, classical guitar, faith, and the communities that help people become more capable of showing up for one another.',
};

// Posts will move here as individual pieces are written. Keeping the data separate
// from the page now will make the eventual blog archive and article pages simple.
export const posts = [];
